const mapboxgl = require('mapbox-gl')

exports.rtlPluginUrl = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.1.0/mapbox-gl-rtl-text.js'

exports.version = {
	full: '0.1.0',
	major: 0,
	minor: 1,
	patch: 0
}



// WEBPACK FOOTER //
// ./src/constants/Constants.js